// Segment events that let us tell, per session, why a route line on the map
// changed: a stored route redraw vs. a fresh ad-hoc calculation, and which
// pointer interaction scheduled the latter.

export type RouteDragKind = "waypoint" | "routeline"

export interface RouteDragSummary {
  kind: RouteDragKind
  endedAt: number
  // Largest per-axis pointer travel, same metric as the library's dragThreshold
  distancePx: number
  belowThreshold: boolean
}

// Short, stable fingerprint so two draws of the same geometry can be compared
// across events without shipping the polylines themselves.
export function fingerprintPolylines(
  polylines: string[] | null,
): string | null {
  if (!polylines) return null
  let hash = 0x811c9dc5
  for (const line of polylines) {
    for (let i = 0; i < line.length; i++) {
      hash ^= line.charCodeAt(i)
      hash = Math.imul(hash, 0x01000193)
    }
    hash ^= 0x7c // leg separator
    hash = Math.imul(hash, 0x01000193)
  }
  return (hash >>> 0).toString(16).padStart(8, "0")
}

export function trackRouteEvent(
  name: "MapAdHocRouteRequest" | "MapStoredRouteDrawn",
  properties: Record<string, unknown>,
) {
  try {
    window.analytics?.track(name, properties)
  } catch {
    // Telemetry must never break the map
  }
}
